import { withStyles } from '@material-ui/core/styles'

import Tabs from '@material-ui/core/Tabs'

const styles = () => ({
  overrides: {
    MuiTabs: {
      root: {
        minHeight: '40px',
        scrollX: 'auto',
        MuiTabIndicatorColorSecondary: {
          backgroundColor: 'transparent',
        },
      },
    },
  },
})

function SecondaryTabs({ value, children }) {
  return <Tabs value={value}>{children}</Tabs>
}

export default withStyles(styles)(SecondaryTabs)
